import React, { useState, useEffect, useRef } from "react";

import PhoneNumberInput from "../custom/PhoneNumberInput";

const MobileOutlined = ({ size = 16, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
    <path d="M12 18h.01" />
  </svg>
);

const OtpGeneration = ({
  country,
  setCountry,
  mobileNumber,
  setMobileNumber,
  onSendOtp,
  isSending,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setIsDropdownOpen(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  const handleSend = () => {
    if (mobileNumber.length !== 10 || isSending) return;
    onSendOtp(mobileNumber, country);
  };

  // const handleResend = () => {
  //     if (!canResend) return;
  //     // setIsSending(true);
  //     // Simulate API call delay
  //     setTimeout(() => {
  //       onSendOtp(mobileNumber);
  //       startTimer();
  //       // setIsSending(false);
  //     }, 1500);
  // };

  const isMobileValid = mobileNumber.length === 10;
  const isCodeValid = country;
  const buttonDisabled = !isMobileValid || !isCodeValid || isSending;

  return (
    <div className="form-section">
      <div className="input-group">
        <label htmlFor="mobile" className="label">
          Enter Mobile Number
        </label>
        <PhoneNumberInput
          value={mobileNumber}
          otherProps={{
            maxLength: 10,
            placeholder: "Enter mobile number",
          }}
          required
          inputName={"mobileNo"}
          countryCodeName={"countryCode"}
          updateInput={(e) => {
            // Only allow digits
            const value = e.target.value.replace(/\D/g, "");
            setMobileNumber(value);
          }}
          type="tel"
          countryCode={country}
          callback={setCountry}
        />
        {!isMobileValid && mobileNumber.length > 0 && (
          <p className="error-message">Mobile number must be 10 digits.</p>
        )}
        {!isCodeValid && country.length > 0 && (
          <p className="error-message">Please entry country code</p>
        )}
      </div>

      <div className="button-group">
        <button
          onClick={handleSend}
          disabled={buttonDisabled}
          className={`btn btn-primary ${buttonDisabled ? "disabled" : ""}`}
        >
          {isSending ? (
            <div className="spinner"></div>
          ) : (
            <>
              <MobileOutlined size={16} className="icon-margin" /> Send OTP
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default OtpGeneration;
